import type { PetStats } from '.';
import type { PetAttribute, PetStatusEffect } from '../';
import { attributeBounds } from '../pet.ruleset';

export function setAttribute(
  { pet }: PetStats.MutableState,
  attribute: PetAttribute,
  value: number,
  now: number,
): void {
  const attributeValue = pet.attributes[attribute];
  attributeValue.value = Math.max(
    attributeBounds.min,
    Math.min(value, attributeBounds.max),
  );
  attributeValue.lastUpdatedAt = now;
}
/**
 * Only for internal use!
 * Use fate.resolveStatusEffect() instead
 *
 * @deprecated
 */
export function setStatusEffect(
  state: PetStats.MutableState,
  statusEffect: PetStatusEffect,
  value: boolean,
  now: number,
): void {
  const effect = state.pet.statusEffects[statusEffect];
  const oldValue = effect.value;
  effect.value = value;
  effect.lastUpdatedAt = now;

  // Clear resolution attempts if the effect was resolved
  if (oldValue && !value) {
    effect.resolutionAttempts = 0;
  }
}

export function incrementResolutionAttempts(
  { pet }: PetStats.MutableState,
  statusEffect: PetStatusEffect,
) {
  pet.statusEffects[statusEffect].resolutionAttempts += 1;
}
